import useWindowSize from './useWindowSize';

export default function useDatePickerPortal(portalWidth = 482) {
  const { width } = useWindowSize();
  const isDatePickerPortal = width <= portalWidth;
  return isDatePickerPortal;
}
